import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalHeadline: {
    defaultMessage: 'Kostenlose Musterbestellung',
    id: 'sampleOrder.modalHeadline',
  },
  sampleOrderCtALinkFabricPattern: {
    defaultMessage: 'Kostenlos Stoffmuster bestellen',
    id: 'sampleOrderCtA.link.fabricPattern',
  },
  sampleOrderCtALinkWoodPattern: {
    defaultMessage: 'Kostenlos Holzmuster bestellen',
    id: 'sampleOrderCtA.link.woodPattern',
  },
});
